import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useCoverStore = defineStore('cover', () => {
  const coverIsLoading = ref(false);

  return {
    coverIsLoading,
  };
});
